import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import ResizableNotes from './ResizableNotes'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { getYear } from 'utils/DateUtil'
import CollectivityAction from 'rpqs/actions/CollectivityAction'
import { DialogActionsTitle } from 'components/styled/Dialog'
import { isNil } from 'lodash'

const EntityIndicatorDialog = ({
    open = false,
    setOpen = () => {},
    children,
    registerAction = () => {},
    calculationOnRegister = () => {},
    onClose = () => {},
    title = '',
    actions = [],
    hasNote = false,
    entityDialog='',
    codeIndicator='',
    setEntityDialog=() => {},
    readMode=false,
    setReadMode,
    height,
    panelProps = {},
}) => {
    const {
        managementEntity,
    } = useSelector(store => ({
        managementEntity: store.CollectivityReducer.managementEntity,
    }), shallowEqual)

    const dispatch = useDispatch()

    const handleClose = () => {
        onClose()
        setEntityDialog(managementEntity)
        setOpen(false)
    }

    const handleClickRegister = () => {
        const entity = calculationOnRegister(entityDialog) || entityDialog
        const year = getYear(entity?.dateEnd)
        const currentEntity = entity?.[year]

        registerAction()

        // Remove acquittal if indicator value change
        if (managementEntity?.[year]?.[codeIndicator]?.value !== currentEntity?.[codeIndicator]?.value && currentEntity?.[codeIndicator]?.warningAcquitted) {
            const newEntity = {
                ...entity,
                [year]: {
                    ...currentEntity,
                    [codeIndicator]: {
                        ...currentEntity?.[codeIndicator],
                        warningAcquitted: false,
                    },
                },
            }


            dispatch(CollectivityAction.updateEntity(newEntity))
            return
        }

        dispatch(CollectivityAction.updateEntity(entity))
    }

    const titleActions = [
        ...actions,
        {
            icon: 'edit',
            tooltip: i18n.switchInputMode,
            onClick: () => setReadMode(false),
            displayed: !isNil(setReadMode) && readMode,
        }, {
            icon: 'edit_off',
            tooltip: i18n.switchToAuto,
            onClick: () => setReadMode(true),
            displayed: !isNil(setReadMode) && !readMode,
        },
        {
            icon: 'close',
            tooltip: i18n.close,
            onClick: handleClose,
        },
    ]

    return (
        <Dialog
            onClose={handleClose}
            open={open}
            maxWidth='xl'
        >
            <DialogActionsTitle
                title={title}
                actions={titleActions}
            />
            <DialogContent sx={{ minHeight: 400, height }}>
                {hasNote ?
                    <ResizableNotes
                        panelContent={panelProps.content}
                        panelTitle={panelProps.title}
                        minWidth={panelProps.minWidth}
                    >
                        {children}
                    </ResizableNotes>
                    :
                    <>{ children }</>
                }
            </DialogContent>
            <DialogActions>
                <Button
                    variant='contained'
                    disableElevation
                    onClick={handleClickRegister}
                >
                    {i18n.register}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

EntityIndicatorDialog.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    children: PropTypes.element,
    registerAction: PropTypes.func,
    calculationOnRegister: PropTypes.func,
    onClose: PropTypes.func,
    title: PropTypes.string,
    actions: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.shape({
            icon: PropTypes.string,
            tooltip: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.element,
            ]),
            onClick: PropTypes.func,
            displayed: PropTypes.bool,
            'data-cy': PropTypes.string,
        }),
    ])),
    hasNote: PropTypes.bool,
    entityDialog: PropTypes.string,
    codeIndicator: PropTypes.string,
    setEntityDialog: PropTypes.func,
    readMode: PropTypes.bool,
    setReadMode: PropTypes.func,
    height: PropTypes.number,
    panelProps: PropTypes.shape({
        title: PropTypes.string,
        minWidth: PropTypes.number,
        content: PropTypes.element,
    }),
}

export default EntityIndicatorDialog